import { IAny, ICoreContext, IGeneric } from '@msdyn365-commerce/core';
import { DisplayTemplate, ProductRefinerSource /*, RefinerType*/ } from '@msdyn365-commerce/retail-proxy';
import { /*Button, Collapse,*/ ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import RangeRefineItem, { RangeRefineItemType } from './lobas-range-refine-item';
import RefineItem from './lobas-refine-item';
import { ILobasTableRefineItemCommonProps } from './lobas-refine-item.props.common';
import { ILobasTableRefineItemToggleNotification } from './lobas-refine-item-toggle-notification';
import { findMatchingRefinementCriterion, isRangeType } from './lobas-utilities';
import { ILobasTableRefinerHierarchy, ILobasTableRefinerValue } from './lobas-table';
import { IProductRefinerHierarchy } from '@msdyn365-commerce/commerce-entities';
/**
 * Properties associated with the RefineSubmenu component.
 */
export interface ILobasRefineSubmenuProps {
    tempRangeTypeTODO: RangeRefineItemType;
    minValueSliderThumbAriaLabel?: string;
    maxValueSliderThumbAriaLabel?: string;
    tableRefinerHierarchy: IProductRefinerHierarchy;
    selectedRefinerValues: ILobasTableRefinerValue[];
    refineItemCommonProps: ILobasTableRefineItemCommonProps;
    isDisabled: boolean;
    isExpandedOnInitialLoad: boolean;
    context: ICoreContext<IGeneric<IAny>>;
    moduleId: string;
    moduleTypeName: string;
    productCountAriaLabel?: string;
    singleProductCountAriaLabel?: string;
    isMobile?: boolean;

    /**
     * The telemetry content
     */
    telemetryContent?: ITelemetryContent;
    onUpdateRefiners(notfication: Readonly<ILobasTableRefineItemToggleNotification>): void;
    urlBuilder(refiner: ILobasTableRefineItemToggleNotification): string;
}

/**
 * Refine submenu state.
 */
export interface ILobasRefineSubmenuState extends React.ComponentState {
    expanded: boolean;
}

/**
 *
 * The RefineSubmenu component renders the submenu category and child items.
 * This computed observes the stateful category hierarchy object.
 * @extends {React.PureComponent<IRefineSubmenuProps>}
 */
class LobasRefineSubmenu extends React.Component<ILobasRefineSubmenuProps, ILobasRefineSubmenuState> {
    constructor(props: ILobasRefineSubmenuProps) {
        super(props);

        this._onToggleItem = this._onToggleItem.bind(this);
        this._onToggleSubmenu = this._onToggleSubmenu.bind(this);

        const isExpanded = this.props.isExpandedOnInitialLoad;

        // If (this.props.productRefinerHierarchy.DataTypeValue === ProductRefinerValueDataTypeValue.Range) {
        //     isExpanded = true;
        // }

        this.state = {
            expanded: isExpanded
        };
    }

    public shouldComponentUpdate(nextProps: ILobasRefineSubmenuProps, nextState: ILobasRefineSubmenuState): boolean {
        if (this.state === nextState && this.props === nextProps) {
            return false;
        }
        return true;
    }

    public render(): JSX.Element | null {
        const { tableRefinerHierarchy, refineItemCommonProps } = this.props;

        if (!tableRefinerHierarchy) {
            refineItemCommonProps.telemetry.error('Cannot render submenu without refiner hierarchy data');
        }

        if (tableRefinerHierarchy.SourceValue === ProductRefinerSource.Rating && this.props.context.app.config.hideRating) {
            return null;
        }
        return (
            /*<div className={`ms-refine-submenu list-group ${tableRefinerHierarchy.KeyName}`}>
                <Button
                    className={this.state.expanded ? 'ms-refine-submenu__toggle_expanded' : 'ms-refine-submenu__toggle_collapsed'}
                    aria-label={tableRefinerHierarchy.KeyName || 'refiner.Name'}
                    onClick={this._onToggleSubmenu}
                    aria-expanded={this.state.expanded}
                >
                    {tableRefinerHierarchy.KeyName}
                </Button>
                <Collapse isOpen={this.state.expanded} timeout={350}>
                    {this._renderChildItems(tableRefinerHierarchy)}
                </Collapse>
            </div>*/

            <div className='lobas-dropdown-group'>
                <label className={'msc-l-dropdown__label'} htmlFor={tableRefinerHierarchy.KeyName}>
                    {tableRefinerHierarchy.KeyName || 'refiner.Name'}
                </label>
                {this._renderChildItems(tableRefinerHierarchy)}
            </div>
        );
    }

    private _renderChildItems(tableRefinerHierarchy: ILobasTableRefinerHierarchy): JSX.Element | null {
        if (isRangeType(tableRefinerHierarchy.DataTypeValue)) {
            return this._renderRange(tableRefinerHierarchy);
        }
        return this._renderSingleMultiSelect(tableRefinerHierarchy);
    }

    private _renderSingleMultiSelect(tableRefinerHierarchy: ILobasTableRefinerHierarchy): JSX.Element | null {
        const {
            isDisabled,
            refineItemCommonProps,
            selectedRefinerValues,
            context,
            productCountAriaLabel,
            singleProductCountAriaLabel,
            isMobile
        } = this.props;
        //const isSingleSelect = tableRefinerHierarchy.RefinerTypeValue === RefinerType.SingleSelect;
        //const role = isSingleSelect ? { role: 'radiogroup' } : undefined;
        const refinerValuesList = tableRefinerHierarchy.Values || [];
        const listItems = refinerValuesList.map((child: ILobasTableRefinerValue, index: number) => {
            if (!child) {
                refineItemCommonProps.telemetry.error(
                    `[refine-submenu] Could not render refine item for refiner ${tableRefinerHierarchy.RecordId} (${tableRefinerHierarchy.KeyName})`
                );
                return null;
            }

            const selectedRefinementCriterion = findMatchingRefinementCriterion(child, selectedRefinerValues);
            // eslint-disable-next-line no-debugger

            return (
                <RefineItem
                    parentTableRefinerHierarchy={tableRefinerHierarchy}
                    tableRefinerValue={child}
                    selectedRefinementCriterion={selectedRefinementCriterion}
                    selectedRefinerValues={selectedRefinerValues.filter(selectedValue =>
                        refinerValuesList.find(value => value.RefinerRecordId === selectedValue.RefinerRecordId)
                    )}
                    refineItemCommonProps={refineItemCommonProps}
                    onToggle={this._onToggleItem}
                    urlBuilder={this.props.urlBuilder}
                    isDisabled={isDisabled}
                    key={index}
                    index={index}
                    context={context}
                    moduleId={this.props.moduleId}
                    moduleTypeName={this.props.moduleTypeName}
                    telemetryContent={this.props.telemetryContent}
                    tableCountAriaLabel={productCountAriaLabel}
                    singleTableCountAriaLabel={singleProductCountAriaLabel}
                    isMobileView={isMobile}
                />
            );
        });
        return (
            <select
                className={`msc-l-dropdown ${tableRefinerHierarchy.KeyName}`}
                /*{...role}*/
                aria-label={tableRefinerHierarchy.KeyName}
                //onChange={this._onClick}
                //multiple={true}
                disabled={isDisabled}
            >
                {listItems}
            </select>
        );
    }

    private _getRangeType(tableRefinerHierarchy: ILobasTableRefinerHierarchy): 'input' | 'slider' {
        if (
            tableRefinerHierarchy.DisplayTemplateValue === DisplayTemplate.Range ||
            tableRefinerHierarchy.DisplayTemplateValue === DisplayTemplate.Slider ||
            tableRefinerHierarchy.DisplayTemplateValue === DisplayTemplate.SliderWithBars
        ) {
            return 'slider';
        }
        return 'input';
    }

    private _renderRange(tableRefinerHierarchy: ILobasTableRefinerHierarchy): JSX.Element | null {
        const {
            isDisabled,
            refineItemCommonProps,
            selectedRefinerValues,
            context,
            minValueSliderThumbAriaLabel,
            maxValueSliderThumbAriaLabel
        } = this.props;
        const submenuClassNamePrefix = 'ms-refine-submenu__item list-group-item refine-submenu__item';
        const refinerValuesList = tableRefinerHierarchy.Values || [];
        const listItems = refinerValuesList.map((child: ILobasTableRefinerValue, index: number) => {
            if (!child) {
                refineItemCommonProps.telemetry.error(
                    `Could not render refine item for refiner ${tableRefinerHierarchy.RecordId} (${tableRefinerHierarchy.KeyName})`
                );
                return null;
            }

            const selectedRefinementCriterion = findMatchingRefinementCriterion(child, selectedRefinerValues);

            const rangeType = this._getRangeType(tableRefinerHierarchy);
            const key = selectedRefinementCriterion
                ? `${selectedRefinementCriterion.LeftValueBoundString}-${selectedRefinementCriterion.RightValueBoundString}`
                : `not-selected-${index}`;
            return (
                <li className={`${submenuClassNamePrefix}--range`} key={index}>
                    <RangeRefineItem
                        parentTableRefinerHierarchy={tableRefinerHierarchy}
                        tableRefinerValue={child}
                        selectedRefinementCriterion={selectedRefinementCriterion}
                        refineItemCommonProps={refineItemCommonProps}
                        onToggle={this._onToggleItem}
                        urlBuilder={this.props.urlBuilder}
                        isDisabled={isDisabled}
                        rangeType={rangeType}
                        key={key}
                        sliderKey={key}
                        context={context}
                        minValueSliderThumbAriaLabel={minValueSliderThumbAriaLabel}
                        maxValueSliderThumbAriaLabel={maxValueSliderThumbAriaLabel}
                        moduleId={this.props.moduleId}
                        moduleTypeName={this.props.moduleTypeName}
                    />
                </li>
            );
        });
        return <ul className={`ms-refine-submenu__list list-unstyled ${tableRefinerHierarchy.KeyName}`}>{listItems}</ul>;
    }

    private _onToggleItem(itemToggleNotification: ILobasTableRefineItemToggleNotification): void {
        this.props.onUpdateRefiners(itemToggleNotification);
    }

    private _onToggleSubmenu(): void {
        this.setState(prevState => ({
            expanded: !prevState.expanded
        }));
    }
}

export default LobasRefineSubmenu;
